<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="filters.WID" placeholder="仓库列表" @change="getList" size="small" :disabled="!filters.IsAdmin">
            <el-option v-for="item in warehouses" :key="item.DataID" :value="item.DataID" :label="item.Code+item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.OwnerID" placeholder="货主" @change="getList" size="small">
            <el-option v-for="item in ownerList" :key="item.DataID" :value="item.DataID" :label="item.Code+item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.KeyWord" placeholder="库存编码/包裹编码" size="small"></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-input v-model="filters.SPU" placeholder="SPU"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-autocomplete   
            :fetch-suggestions="querySearchSpu"   
            @select="handleSelectSpu"  
            placeholder="SPU / Name / SkuID"  
            size="small"
          >  
          </el-autocomplete>  
        </el-form-item>
        <el-form-item>
          <el-autocomplete   
            :fetch-suggestions="querySearchAsync"   
            @select="handleSelectSearch"  
            placeholder="ID / SKU / Name"  
            size="small"
            style="width: 300px;"
          >  
          </el-autocomplete>  
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getList">查询</el-button>
          <el-button type="primary" size="small" @click="downloadFile">下载库存编码</el-button>
          <el-button type="primary" size="small" @click="PrintPDF">打印库存编码</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table id="pdfDom" :data="WQCList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" border>
      <el-table-column type="selection">
      </el-table-column>
      <el-table-column prop="DataID" label="序号" width="50">
      </el-table-column>
      <el-table-column label="位置" width="80">
        <template slot-scope="scope">
            <p>{{scope.row.GeoCode.Code}}</p>
        </template>
      </el-table-column>
      <el-table-column label="库存编码/包裹编码/入库单号" width="180">
        <template slot-scope="scope">
            <p>{{scope.row.OrderID}}/{{scope.row.Package.FreightNo}}/<el-button type="text" @click="LinkToStockIn(scope.row.StockIn.StockInOrder)">{{scope.row.StockIn.StockInOrder}}</el-button></p>
        </template>
      </el-table-column>
      <el-table-column label="包含产品" width="300">
        <template slot-scope="scope">
            <p v-for="p in scope.row.Package.Product" :key="p.DataID">[{{p.Product.Status}}] [{{p.Product.FullName}}] {{p.Product.FullSKU}} * {{p.Product.Quantity}}</p>
        </template>
      </el-table-column>
      <el-table-column label="包裹规格" width="">
        <template slot-scope="scope">
          <p class="package-info" @click="editModel(true, scope)">{{scope.row.Package.Weight}} g<br>{{scope.row.Package.Length}}*{{scope.row.Package.Width}}*{{scope.row.Package.Height}}cm <span class="package-info-msg" v-if="!scope.row.ExecuteQC">包裹规格需完善</span></p>
        </template>
      </el-table-column>
      <el-table-column label="属性" width="80">
        <template slot-scope="scope">
          <el-tag type="danger" v-show="scope.row.StockIn.Level!=='普通'">{{scope.row.StockIn.Level | changePara}}</el-tag>
          <el-tag type="primary" v-show="scope.row.StockIn.NewProduct!=='普通'">{{scope.row.StockIn.NewProduct | changePara}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="待质检数量" prop="Quantity" width="100">
      </el-table-column>
      <el-table-column label="执行数量" prop="">
        <template slot-scope="scope">
        <el-input placeholder="" v-model="scope.row.executeQuantuty" :disabled="!scope.row.ExecuteQC"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="UpdateDate" label="时间" width="">
        <template slot-scope="scope">
            <p>{{scope.row.UpdateDate | cutDate}}</p>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->

    <el-col :span="24" class="toolbar">
      转入库区 
      <el-select v-model="WARID" placeholder="库区列表" size="small">
        <el-option v-for="item in WAList" :key="item.DataID" :value="item.DataID" :label="item.ACode+' - '+item.Types">
        </el-option>
      </el-select>
      <el-button type="primary" @click="execute" :disabled="this.sels.length===0 || listLoading" size="small">执行</el-button>
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-sizes="[20, 30, 50, 100]" :page-size="pageSize" :total="total" style="float:right;" @size-change="handleSizeChange">
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editModelShow" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="100px" ref="editForm">
        <el-form-item label="重量">
          <el-col :span="3"><el-input v-model="editForm.Weight" id="editformWeight"></el-input></el-col> 
          <el-col :span="5"><label>单位g</label></el-col>
          <el-col :span="2"><label>规格</label></el-col> 
          <el-col :span="3"><el-input v-model="editForm.Length"></el-input></el-col>
          <el-col :span="3"><el-input v-model="editForm.Width"></el-input></el-col>
          <el-col :span="3"><el-input v-model="editForm.Height"></el-input></el-col>
          <el-col :span="5"><label>长宽高，单位cm</label></el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editModel(false)">取消</el-button>
        <el-button type="primary" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
  import util from '../../common/js/util'
  //import NProgress from 'nprogress'
  import { BaseUrl, getWQCList, WPSkuSearch, getWarehouseList, getOwnerListTree, getWAList, getWAListTree, executeWQC, SpuSearch, WQCDownLoad, WQCPrint, updatePackageInfo} from '../../api/api'
  let qs = require('qs')
  export default {
    data() {
      return {
        filters: {
          WID: '',
          IsAdmin: '',
          OwnerID:'',
          SkuID:'',
          SkuIDs:'',
          KeyWord:''
        },
        // 编辑界面
        editModelShow: false,
        editCurrentIndex: '',
        editForm: {
          DataID: '',
          Weight: '',
          Length: '',
          Width: '',
          Height: ''
        },
        warehouses: [],
        ownerList:[],
        WQCList:[],
        WAList:[],
        WARID:'',
        total: 0,
        page: 1,
        pageSize:20,
        // size: 20,
        listLoading: false,
        sels: [],//列表选中列
        //搜索完成的显示名称
        skuName: '',
        searchName:'',
        htmlTitle: '质检单'
      }
    },
    // 自定义指令
    // directives: {
    //   focus: {
    //     inserted (el) {
    //       el.focus()
    //     }
    //   }
    // },
    methods: {
      //改变页数
      handleCurrentChange (val) {
        this.page = val
        this.getList()
      },//改变每页显示数量
      handleSizeChange (val) {
        this.pageSize = val
        this.getList()
      },
      //获取质检数据列表
      getList () {
        let para = {
          Page: this.page,
          QueryLimitNumber: this.pageSize,
          SkuID: this.filters.SkuID,
          SkuIDs: this.filters.SkuIDs,
          OwnerID: this.filters.OwnerID,
          WID: this.filters.WID,
          KeyWord: this.filters.KeyWord
          // Mode: 'InService'
        }
        this.listLoading = true
        // NProgress.start();
        this.getWaTree({WID: para.WID})
        getWQCList(para).then((res) => {
          if (res.data.Ack) {
            this.total = res.data.Pagination.TotalNumberOfEntries
            this.WQCList = res.data.DataList
          } else {
            util.error(this,res.data)
            this.WQCList = []
            this.total = 0
          }
          if (this.filters.WID === '' && this.filters.IsAdmin === '') {
            this.filters.WID = res.data.Head.WID
            this.filters.IsAdmin = res.data.Head.IsAdmin
          }
          this.listLoading = false
          // NProgress.done();
        })
      },
      // 打开编辑包裹规格的模态框，并设置PID
      editModel (show, scope) {
        if (show) {
          this.editCurrentIndex = scope.$index
          this.editForm.DataID = scope.row.PID
          this.editForm.Weight = scope.row.ExecuteQC ? scope.row.Package.Weight : ''
          this.editForm.Length = scope.row.ExecuteQC ? scope.row.Package.Length : ''
          this.editForm.Width = scope.row.ExecuteQC ? scope.row.Package.Width : ''
          this.editForm.Height = scope.row.ExecuteQC ? scope.row.Package.Height : ''
          this.editModelShow = true

          this.$nextTick(() => {
            document.getElementById('editformWeight').focus()
          })
          
        } else {
          this.editModelShow = false
          this.editForm.DataID = ''
          this.editCurrentIndex = ''
        }
      },
      // 提交包裹规格
      editSubmit () {
        if (this.editForm.Weight === '' || this.editForm.Length === '' || this.editForm.Width === '' || this.editForm.Height === '') {
          this.$message({
            type: 'warning',
            message: '信息不完善.'
          })
          return
        }
        let parm = qs.stringify({
          DataID: this.editForm.DataID,
          Weight: this.editForm.Weight,
          Length: this.editForm.Length,
          Width: this.editForm.Width,
          Height: this.editForm.Height
        })
        updatePackageInfo(parm).then(res => {
          if (res.data.Ack) {
            this.$message({
              type: 'success',
              message: res.data.Message
            })
            this.WQCList[this.editCurrentIndex].ExecuteQC = true
            this.WQCList[this.editCurrentIndex].Package.Height = res.data.Head.Height
            this.WQCList[this.editCurrentIndex].Package.Length = res.data.Head.Length
            this.WQCList[this.editCurrentIndex].Package.Weight = res.data.Head.Weight
            this.WQCList[this.editCurrentIndex].Package.Width = res.data.Head.Width
            this.editModelShow = false
          }
        })
      },
      //搜索SPU
      //queryString 为在框中输入的值
      //callback 回调函数,将处理好的数据推回
      querySearchSpu (queryString, callback) {
        if (!queryString) {
          this.filters.SkuIDs = ''
          return
        }
        let para = qs.stringify({
          KeyWord: queryString
        })
        var list = [{}]
         //从后台获取到对象数组
        SpuSearch(para).then((res) => {
          //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示  
          for (let i of res.data.Spu) {
            i.value  = '[' + i.SPU + ']' + i.Name  //将CUSTOMER_NAME作为value  
          }
          list = res.data.Spu
          callback(list)
        }).catch((error) => {  
          console.log(error) 
        })
      },
      //搜索栏选中后的处理函数
      handleSelectSpu (item) {
        this.filters.SkuIDs = item.SkuIDList
        // this.searchName = item.FullName
        this.getList()
      },
      //搜索SKU
      //queryString 为在框中输入的值  
      //callback 回调函数,将处理好的数据推回  
      querySearchAsync (queryString, callback) {
        if (!queryString) {
          this.filters.SkuID = ''
          return
        }
        let para = qs.stringify({
          KeyWord: queryString
        })
        var list = [{}]
        //从后台获取到对象数组
        WPSkuSearch(para).then((res) => {
          //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示
          for (let i of res.data.DataList) {
            i.value  = '[' + i.Status + ']' + '[' + i.FullSKU + ']' + i.FullName  //将CUSTOMER_NAME作为value  
          }
          list = res.data.DataList
          callback(list)
        }).catch((error) => {
          console.log(error) 
        })
      },
      //搜索栏选中后的处理函数
      handleSelectSearch (item) {
        this.filters.SkuID = item.DataID
        this.searchName = item.FullName
        this.getList()
      },
      selsChange (sels) {
        this.sels = sels
      },
      //执行质检操作
      execute () {
        this.listLoading = true
        let stockJson = []
        this.sels.forEach(function (item, index) {
          item.executeQuantuty && stockJson.push({DataID:item.DataID,Quantity:item.executeQuantuty})
        })
        let para = JSON.stringify({ WARID: this.WARID, Stock:stockJson})
        executeWQC(para).then((res) => {
          //NProgress.done();
          if (res.data.Ack) {
            this.$message({
              message: '执行质检操作成功',
              type: 'success'
            })
            this.getList()
          } else {
            util.error(this,res.data)
          }
          this.$nextTick(function () {
            /*数据已经渲染完毕*/
            this.listLoading = false
          })
        })
      },
      //导出库存编码表格
      downloadFile () {
        let para = qs.stringify({
          SkuID: this.filters.SkuID,
          SkuIDs: this.filters.SkuIDs,
          OwnerID: this.filters.OwnerID,
          WID: this.filters.WID,
          KeyWord: this.filters.KeyWord
        })
        WQCDownLoad(para).then((res) => {
          this.listLoading = false
          if (res.data.Ack) {
            this.$message({
              message: '导出库存编码表格',
              type: 'success'
            })
            location.href = util.baseUrl(res.data.Create.File)
          } else {
            util.error(this,res.data)
          }
        })
      },
      // 打印PDF
      PrintPDF () {
        if (this.sels.length <= 0) {
          this.$message({
            message: '未选择任何数据.',
            type: 'warning'
          })
          return
        }
        let para = JSON.stringify(this.sels.map(v => {
          return {
            StockID: v.DataID,
            Quantity: v.Quantity
          }
        }))
        WQCPrint(para).then(res => {
          if (res.data.Ack) {
            util.LODOPrint(this, res.data.TotalPDF, 700, 200, res.data.PrintTypes)
          } else {
            util.error(this,res.data)
          }
        })
      },
      //获取仓库列表,用于搜索查询
      getwarehouses () {
        getWarehouseList().then((res) => {
          this.warehouses = res.data.DataList
        })
      },
      //获取货主简化列表，用于搜索查询
      getOwnerList () {
        getOwnerListTree().then((res) => {
          this.ownerList = res.data.DataList
        })
      },
      //获取库区列表
      // getWA () {
      //   getWAList({WID: this.filters.WID}).then((res) => {
      //     this.WAList = res.data.DataList
      //   })
      // },
      // 获取简易库区列表
      getWaTree (data) {
        getWAListTree(qs.stringify(data)).then(res => {
          this.WAList = res.data.WarehouseArea
        })
      },
      /**
       * 点击入库单号，跳转到入库列表，并打开对应入库详情框
       * @param {string} orderID 入库单号
       */
      LinkToStockIn (orderID) {
        this.$router.push({name: '入库单列表', params: {orderID: orderID}})
      }
    },
    filters: {
      cutDate (date) {
        return date.split(' ')[0]
      },
      changePara (value) {
        value === '普通' ? value = '' : value = value
        return value
      }
    },
    mounted() {
      this.getList()
      this.getwarehouses()
      this.getOwnerList()
    }
  }
</script>

<style scoped>
  .el-form-item{
    margin-bottom: 10px!important;
  }
  .package-info {
    cursor: pointer;
  }
  .package-info-msg {
    font-size: 12px;
    color: #f77;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// WQCList.vue?6a79908c